import React, { useState } from "react";
import { ConversationsBubbleType } from "../../../../libraries/types_interface/chats/ChatsTypes";
import { LogoImage } from "../../../../widget/common/ui/Logo";
import { useDispatch } from "react-redux";
import { chatResfreshTimeStamp } from "../../../../libraries/state_reducers/chats/ChatsReducer";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import SessionStorage from "../../../../service/storage/SessionStorage";
import StorageKeys from "../../../../const/StorageKeys";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import ModalKeys from "../../../../const/ModalKeys";
import { addModal } from "../../../../libraries/state_reducers/widget/ModalsReducer";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";

const BubbleImage: React.FC<ConversationsBubbleType> = ({
  message,
  imageSize = 200,
  longPressStatus = false,
}) => {
  const dispatch = useDispatch();
  const type: number = ResponsiveDeviceType();

  const [isValid, setIsValid] = useState<boolean>(false);

  const loadedCallBack = (status?: boolean) => {
    console.log(`loadedCallBack`, status);
    dispatch(chatResfreshTimeStamp());
    setIsValid(status ?? false);
  };

  let url: string = "",
    name = "";

  if (message.split("|").length) {
    url = message.split("|")[1];

    const namesArr: Array<string> = url.split("/");
    name = namesArr[namesArr.length - 1];
  }

  const handleClick = () => {
    if (!longPressStatus && isValid) {
      if (UtilityHelper.isNotEmpty(url)) {
        SessionStorage.saveValue(
          StorageKeys.preview_image_document,
          JSON.stringify({
            title: "",
            url: url,
          })
        );

        dispatch(
          addModal({
            id:
              type === 3
                ? ModalKeys.preview_image_document
                : ModalKeys.chat_preview_image_document,
            title: AppTranslation.text("preview"),
            screenMobileView: type === 3 ? false : true,
          })
        );
      }
    }
  };

  return (
    <div className="bubble-image">
      <div role={isValid ? "button" : "none"} onClick={handleClick}>
        <LogoImage
          url={url}
          size={imageSize}
          name={name}
          fixedHieght={true}
          showErrorImage={true}
          loadedCallBack={loadedCallBack}
        />
      </div>
    </div>
  );
};

export default BubbleImage;
